import { SPIFF_RULE_EVENTS } from "@/spiff-rules/constants";
import { BaseSpiff } from "@/spiffs/spiffs.d";

/**
 * Dynamically calculate spiff counts by event type following the {event}_count convention.
 * This ensures consistency across all spiff aggregations.
 */
export interface SpiffEventCounts {
  signup_count: number;
  referral_creation_count: number;
  referral_completion_count: number;
  five_star_review_count: number;
  yard_sign_photo_count: number;
  pricebook_item_sale_count: number;
  tech_generated_lead_count: number;
  driving_score_count: number;
  generic_count: number;
  total_amount: number;
}

export const calculateSpiffCounts = (spiffs: BaseSpiff[]): SpiffEventCounts => {
  // Dynamically calculate counts for each event type
  const eventCounts = Object.values(SPIFF_RULE_EVENTS).reduce(
    (acc, event) => {
      acc[`${event}_count`] = spiffs.filter(
        (spiff) => spiff.trigger_event === event,
      ).length;
      return acc;
    },
    {} as Record<string, number>,
  );

  // Calculate total amount
  const total_amount = spiffs.reduce(
    (acc, spiff) => acc + Number(spiff.amount || 0),
    0,
  );

  return {
    ...eventCounts,
    total_amount,
  } as SpiffEventCounts;
};
